import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Button from '@mui/material/Button';
import Container from "@mui/material/Container";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { withRouter } from "react-router";

import UserBar from "../components/UserBar";
import axios from "../components/Axios";


class Index extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            project: {
                project_name: "Video Title",
                project_id: null,
                status: 'LOADING'
            },
            loading: false,
            subtasks: [],
            jobs: [],
            pods: []
        };
        this.navTo = this.navTo.bind(this);
        this.timeout = null;
    }

    componentDidMount() {
        this.getItems();
    }

    componentWillUnmount() {
        if (this.timeout !== null) clearTimeout(this.timeout);
    }

    getItems() {
        //video progress
        this.setState({ loading: true });
        axios
            .get("/project_progress/" + this.props.match.params.project_id)
            .then(
                function (response) {
                    this.setState({ loading: false, ...response.data });

                    let diff = Date.now() / 1000 - response.data.project.created_time_z
                    if (diff < 3600) {
                        this.timeout = setTimeout(() => {
                            this.getItems();
                        }, 10000)
                    } else if (diff < 3600 * 3) {
                        this.timeout = setTimeout(() => {
                            this.getItems();
                        }, 60000)
                    }

                }.bind(this)
            )
            .catch(
                function (error) {
                    console.log(error);
                    this.setState({ loading: false });
                }.bind(this)
            );
    }

    navTo(p, e) {
        e.preventDefault();
        this.props.history.push(p);
    }

    formatDate(u) {
        if (u == null) return '';
        let d = new Date(u)
        return d.toLocaleString();
    }

    render() {
        return (
            <>
                <UserBar
                    title={this.state.project.project_name}
                    subtitle=""
                    align="flex-end"
                >
                    <Tabs
                        value={this.props.match.params.tab || "summary"}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab
                            label="Progress"
                            value="summary"
                        />
                    </Tabs>
                </UserBar>
                <Container maxWidth="lg" style={{ paddingTop: "32px" }}>
                    <div className="queryTitle">Status</div>
                    <div style={{ margin: "0 0 24px 0" }}>{this.state.project.status}</div>
                    <div className="queryTitle" style={{ marginBottom: '24px' }}>Subtasks</div>
                    <Paper style={{ maxWidth: '900px' }}>
                        <Table className="invoiceListTable" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Task</TableCell>
                                    <TableCell align="center">Status</TableCell>
                                    <TableCell align="center">Started</TableCell>
                                    <TableCell align="center">Finished</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.subtasks.map((item, index) => (
                                    <TableRow key={item.task_id}>
                                        <TableCell align="center">{item.subtask_type}</TableCell>
                                        <TableCell align="center">{item.job_status}</TableCell>
                                        <TableCell align="center">{this.formatDate(item.started_time_z)}</TableCell>
                                        <TableCell align="center">{this.formatDate(item.finished_time_z)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Paper>
                    <div className="queryTitle" style={{ margin: '24px 0' }}>Server</div>
                    <Paper style={{ maxWidth: '240px' }}>
                        <Table className="invoiceListTable" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Status</TableCell>
                                    <TableCell align="center">Age</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center">{this.state.pods[2]}</TableCell>
                                    <TableCell align="center">{this.state.pods[4]}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>

                    <div className="queryTitle" style={{ margin: '24px 0' }}>Job</div>
                    <Paper style={{ maxWidth: '300px' }}>
                        <Table className="invoiceListTable" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Status</TableCell>
                                    <TableCell align="center">Duration</TableCell>
                                    <TableCell align="center">Age</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center">{this.state.jobs[1]}</TableCell>
                                    <TableCell align="center">{this.state.jobs[3]}</TableCell>
                                    <TableCell align="center">{this.state.jobs[4]}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>

                </Container>
            </>
        );
    }
}

export default withRouter(Index);
